import React, { Component } from 'react';
import _ from 'lodash';
import Validator from 'validatorjs';
import { Button, Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import NominaCatalogoManager from '../../../../catalogs/managers/NominaCatalogoManager';

class NominaOtrosPagosForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      validator: new Validator({}, this.rules),
    };
  }

  get rules() {
    const isSubsidioAlEmpleoRequired = this.isSubsidioAlEmpleoRequired();
    const isCompensacionSaldosAFavorRequired = this.isCompensacionSaldosAFavorRequired();

    return {
      TipoOtroPago: ['required', 'string', 'in:001,002,003,004,005,006,007,008,009,999'],
      Clave: ['required', 'string', 'min:3', 'max:15', 'regex:/^[^|]{3,15}$/'],
      Concepto: ['required', 'string', 'min:1', 'max:100', 'regex:/^[^|]{1,100}$/'],
      Importe: ['required', 'decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      SubsidioCausado: [
        isSubsidioAlEmpleoRequired ? 'required' : 'string',
        'decimal:2',
        'min:0.00',
        'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/',
      ],
      SaldoAFavor: [
        isCompensacionSaldosAFavorRequired ? 'required' : 'string',
        'decimal:2',
        'min:0.00',
        'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/',
      ],
      Año: [isCompensacionSaldosAFavorRequired ? 'required' : 'string', 'integer', 'min:2016'],
      RemanenteSalFav: [
        isCompensacionSaldosAFavorRequired ? 'required' : 'string',
        'decimal:2',
        'min:0.00',
        'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/',
      ],
    };
  }

  componentDidMount() {
    this.fillCatalogs();
  }

  async componentDidUpdate() {
    const { data } = this.props;

    this.fillCatalogs();

    if (!!data) {
      const validator = this.validate({ ...data });

      this.setState({
        data: {
          ...data,
          SubsidioCausado: !!data.SubsidioAlEmpleo && data.SubsidioAlEmpleo.SubsidioCausado,
        },
        isValid: validator.passes(),
      });
    }
  }

  fillCatalogs = async () => {
    if (!this.state.catalogos) {
      const values = await NominaCatalogoManager.get('c_nom_tipo_otro_pago');

      if (!!values) {
        let catalogos = {};

        const sorted = _.sortBy(
          values.map((item) => {
            return {
              label: item.descripcion,
              value: item.tipo,
            };
          }),
          'label'
        );

        catalogos.tipoOtrosPagos = sorted;

        this.setState({
          catalogos,
        });
      }
    }
  };

  validate = (data) => {
    const validator = new Validator(data, this.rules);

    validator.check();

    return validator;
  };

  handleOnChange = (values) => {
    const data = {
      ...this.state.data,
      ...values,
    };

    const validator = this.validate(data);

    this.setState({
      data,
      validator,
      isValid: validator.passes(),
    });
  };

  handleOnAdd = () => {
    let data = {
      ...this.state.data,
    };

    if (!!data.SubsidioCausado) {
      data.SubsidioAlEmpleo = {
        SubsidioCausado: data.SubsidioCausado,
      };

      delete data.SubsidioCausado;
    }

    this.props.onAdd(data);

    this.setState({
      data: {},
      isValid: false,
    });
  };

  isSubsidioAlEmpleoRequired = () => {
    return this.state.data?.TipoOtroPago === '002';
  };

  isCompensacionSaldosAFavorRequired = () => {
    return this.state.data?.TipoOtroPago === '004';
  };

  render() {
    const rules = this.rules;
    const { isValid, data = {}, catalogos = {} } = this.state;

    const isSubsidioAlEmpleoRequired = this.isSubsidioAlEmpleoRequired();
    const isCompensacionSaldosAFavorRequired = this.isCompensacionSaldosAFavorRequired();

    return (
      <>
        <Row>
          <Col
            sm
            md={4}
          >
            <FormControl
              type="select"
              label="Tipo Otro Pago"
              name="TipoOtroPago"
              placeholder=""
              help=""
              options={catalogos.tipoOtrosPagos}
              rules={rules.TipoOtroPago}
              value={data.TipoOtroPago}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Clave"
              name="Clave"
              placeholder=""
              help=""
              minLength="3"
              maxLength="15"
              rules={rules.Clave}
              value={data.Clave}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Concepto"
              name="Concepto"
              placeholder=""
              help=""
              minLength="1"
              maxLength="100"
              rules={rules.Concepto}
              value={data.Concepto}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="number"
              label="Importe"
              name="Importe"
              placeholder=""
              help=""
              min="0"
              rules={rules.Importe}
              value={data.Importe}
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>

        {!!isSubsidioAlEmpleoRequired && (
          <>
            <div>
              <strong>Subsidio al empleo</strong>
            </div>

            <Row>
              <Col
                sm
                md={4}
              >
                <FormControl
                  type="number"
                  label="Subsidio Causado"
                  name="SubsidioCausado"
                  placeholder=""
                  help=""
                  min="0"
                  rules={rules.SubsidioCausado}
                  value={data.SubsidioCausado}
                  onChange={this.handleOnChange}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <span className="text-muted">
                  Si Tipo Regimen del Receptor es 02 debe existir el campo TipoOtroPago con la clave{' '}
                  <strong>002 - Subsidio para el empleo (efectivamente entregado al trabajador)</strong>, siempre que:
                  <ul>
                    <li>No se haya registrado "Otro Pago" con clave 007 - ISR ajustado por subsidio</li>
                    <li>
                      No se haya registrado "Otro Pago" con clave 008 - Subsidio efectivamente entregado que no
                      correspondía (Aplica sólo cuando haya ajuste al cierre de mes en relación con el Apéndice 7 de la
                      guía de llenado de nómina)
                    </li>
                  </ul>
                </span>
              </Col>
            </Row>
          </>
        )}

        {!!isCompensacionSaldosAFavorRequired && (
          <>
            <div>
              <strong>Compensación saldos a favor</strong>
            </div>

            <Row>
              <Col
                sm
                md={4}
              >
                <FormControl
                  type="number"
                  label="Saldo A Favor"
                  name="SaldoAFavor"
                  placeholder=""
                  help=""
                  min="0"
                  rules={rules.SaldoAFavor}
                  value={data.SaldoAFavor}
                  onChange={this.handleOnChange}
                />
              </Col>

              <Col
                sm
                md={4}
              >
                <FormControl
                  type="number"
                  label="Año"
                  name="Año"
                  placeholder=""
                  help=""
                  min="2016"
                  rules={rules.Año}
                  value={data.Año}
                  onChange={this.handleOnChange}
                />
              </Col>

              <Col
                sm
                md={4}
              >
                <FormControl
                  type="number"
                  label="Remanente Saldo Favor"
                  name="RemanenteSalFav"
                  placeholder=""
                  help=""
                  min="0"
                  rules={rules.RemanenteSalFav}
                  value={data.RemanenteSalFav}
                  onChange={this.handleOnChange}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <p className="text-muted">
                  Si se registró la clave "004" (Aplicación de saldo a favor por compensación anual), se debe de
                  registrar información de "Compensación Saldos A Favor".
                </p>
              </Col>
            </Row>
          </>
        )}

        <Row>
          <Col>
            <p className="text-muted">
              Puedes agregar pagos extra usando el botón "Agregar pago", las pagos se mostrarán en la tabla de pagos.
            </p>
          </Col>
        </Row>

        <Row className="pb-3">
          <Col className="text-right">
            <Button
              variant="secondary"
              disabled={!isValid}
              onClick={this.handleOnAdd}
            >
              Agregar pago
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}

export default NominaOtrosPagosForm;
